module.exports = __webpack_public_path__ + "static/img/home-min.81eaa44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home-min.jpg
// module id = fS9H
// module chunks = 35